import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const readSeen = () => {
  try {
    return sessionStorage.getItem("ke_intro") === "1";
  } catch {
    return false;
  }
};

export default function Preloader() {
  const [done, setDone] = useState(readSeen);

  useEffect(() => {
    if (done) return;
    const t = setTimeout(() => {
      try {
        sessionStorage.setItem("ke_intro", "1");
      } catch {}
      setDone(true);
    }, 2300);
    return () => clearTimeout(t);
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.img
            src="/kemelia-logo.png"
            alt="Kemelia Estate — Agence Immobilière"
            data-testid="preloader-logo"
            initial={{ opacity: 0, scale: 0.9, filter: "blur(6px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.5, ease: "easeOut" }}
            className="w-52 sm:w-72"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
